import { subDays, subHours, subMinutes } from "date-fns"
import { DateRange } from "react-day-picker"

// suffix
const PER_MONTH_SUFFIX = "/mo"

// terminology
const CPU_USAGE_VS_REQUEST = "CPU (usage/request)"
const MEMORY_USAGE_VS_REQUEST = "Memory (usage/request)"
const CPU_USAGE_VS_AVAILABLE = "CPU (usage/available)"
const MEMORY_USAGE_VS_AVAILABLE = "Memory (usage/available)"
const NOT_AVAILABLE = "No reliable trend"

// date range
const FIXED_DATE_RANGE_IN_5_MINS: DateRange = {
  from: subMinutes(new Date(), 5),
  to: new Date(),
}

// the drawer keeps its own ranges, separate from the page-level starting-date/ending-date
const DRAWER_CHART_RANGE_PARAMS = { from: "drawer-starting-date", to: "drawer-ending-date" } as const
const EVENT_RANGE_PARAMS = { from: "event-starting-date", to: "event-ending-date" } as const

const FIXED_DATE_RANGE_IN_1_HOUR: DateRange = {
  from: subHours(new Date(), 1),
  to: new Date(),
}

const FIXED_DATE_RANGE_IN_7_DAYS: DateRange = {
  from: subDays(new Date(), 7),
  to: new Date(),
}

enum NavigateType {
  PUSH = "push",
  REPLACE = "replace",
}

export {
  PER_MONTH_SUFFIX,
  CPU_USAGE_VS_REQUEST,
  MEMORY_USAGE_VS_REQUEST,
  CPU_USAGE_VS_AVAILABLE,
  MEMORY_USAGE_VS_AVAILABLE,
  NOT_AVAILABLE,
  FIXED_DATE_RANGE_IN_5_MINS,
  FIXED_DATE_RANGE_IN_1_HOUR,
  FIXED_DATE_RANGE_IN_7_DAYS,
  DRAWER_CHART_RANGE_PARAMS,
  EVENT_RANGE_PARAMS,
  NavigateType,
}
